var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVigilLogoGreyedout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 17,
    viewBox: "0 0 74 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.238 6.54856L25.0399 11.6729L26.8231 6.54856H28.1839L25.6593 13.212H24.4111L21.8771 6.54856H23.238Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5263 13.212V6.54856H35.8214V13.212H34.5263Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6114 13.2589C45.1797 13.2589 44.7698 13.1714 44.3819 12.9962C44.0003 12.821 43.6624 12.5801 43.3683 12.2735C43.0805 11.9607 42.8553 11.5978 42.6926 11.1848C42.5299 10.7719 42.4486 10.3245 42.4486 9.84275C42.4486 9.386 42.5299 8.95742 42.6926 8.55698C42.8553 8.15029 43.0836 7.79366 43.3777 7.48707C43.6718 7.18049 44.0159 6.93961 44.4101 6.76442C44.8042 6.58923 45.2328 6.50163 45.6958 6.50163C46.3215 6.50163 46.8565 6.63615 47.3007 6.90519C47.7512 7.16798 48.0891 7.51836 48.3143 7.95633L47.3476 8.6696C47.1787 8.338 46.9409 8.0846 46.6344 7.90941C46.334 7.73422 46.0055 7.64662 45.6489 7.64662C45.3674 7.64662 45.1108 7.70606 44.8793 7.82494C44.6478 7.94382 44.4476 8.10649 44.2787 8.31297C44.1097 8.51944 43.9784 8.7572 43.8845 9.02624C43.7969 9.29528 43.7531 9.57996 43.7531 9.88029C43.7531 10.1994 43.8 10.4935 43.8939 10.7625C43.994 11.0315 44.1316 11.2662 44.3068 11.4664C44.4883 11.6666 44.6979 11.8261 44.9356 11.945C45.1734 12.0576 45.4362 12.114 45.724 12.114C46.0619 12.114 46.3841 12.0264 46.6907 11.8512C47.0035 11.676 47.2944 11.4195 47.5635 11.0816V12.358C47.0066 12.9586 46.3559 13.2589 45.6114 13.2589ZM47.4696 10.7343H46.1276V9.78644H48.5395V13.212H47.4696V10.7343Z",
    fill: "#727272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2744 13.212V6.54856H56.5696V13.212H55.2744Z",
    fill: "#727272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5909 13.212V6.54856H64.8861V12.0764H68.2835V13.212H63.5909Z",
    fill: "#727272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85718 4.66475C6.45339 10.4057 5.34156 12.311 5.34156 12.4029C5.34156 12.4996 7.15605 15.6438 7.74799 16.5728C7.85774 16.7451 8.11599 16.741 8.21988 16.5652L8.62479 15.8802C8.97369 15.2898 10.7597 12.2716 12.5937 9.1731C14.4275 6.07456 15.9435 3.50242 15.9624 3.4573C15.9813 3.41208 14.7803 3.38705 13.2936 3.40149L12.0537 3.41361C11.1467 3.42247 10.3117 3.89807 9.85718 4.66475Z",
    fill: "url(#paint0_linear_4492_6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98318 7.83617C7.45404 6.94066 6.83193 5.89007 6.10544 4.66476C5.65092 3.89808 4.81598 3.42248 3.90896 3.41362L2.66903 3.4015C1.18236 3.38706 -0.0186244 3.41209 0.000218741 3.45731C0.0191628 3.50243 1.53511 6.07457 3.36896 9.17311C5.2029 12.2717 6.98894 15.2898 7.33784 15.8802L7.74274 16.5652C7.84664 16.741 8.10488 16.7451 8.21464 16.5728C8.53015 16.0776 9.19298 14.9531 9.74325 13.9962L13.3827 7.83921C12.8431 8.74764 11.8365 9.35858 10.6838 9.35857C9.52989 9.35858 8.52234 8.74627 7.98318 7.83617Z",
    fill: "url(#paint1_linear_4492_6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9957 0V0.214747H70.3883V1.80265H70.1404V0.214747H69.533V0H70.9957Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4655 0H71.8152L72.3331 1.52409L72.8472 0H73.1933V1.80265H72.9614V0.73873C72.9614 0.701916 72.9622 0.640969 72.9638 0.555888C72.9654 0.470807 72.9663 0.379591 72.9663 0.282239L72.4521 1.80265H72.2104L71.6925 0.282239V0.33746C71.6925 0.381636 71.6933 0.449128 71.695 0.539935C71.6974 0.629924 71.6986 0.696189 71.6986 0.73873V1.80265H71.4655V0Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4492_6",
    x1: 16.0135,
    y1: 16.5871,
    x2: -0.185172,
    y2: 16.6002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4492_6",
    x1: -3.89492,
    y1: 10.0447,
    x2: 12.016,
    y2: 10.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigilLogoGreyedout);
export default __webpack_public_path__ + "static/media/Vigil Logo Greyed out.965aba009ca76027846065c5a4f1e655.svg";
export { ForwardRef as ReactComponent };